<section class="section-padding-home home-divider-light bg-gradient-to-b from-slate-50 to-white">
  <div class="container-max">
    <!-- Section Header -->
    <div class="text-center mb-16">
      <span class="inline-block px-4 py-2 bg-primary-100 text-primary-700 rounded-full text-sm font-semibold mb-4">
        Our Services
      </span>
      <h2 class="text-4xl lg:text-5xl font-bold text-slate-900 mb-4">
        Comprehensive Construction Solutions
      </h2>
      <p class="text-xl text-slate-600 max-w-2xl mx-auto">
        From residential homes to large-scale commercial projects, we deliver excellence across all construction sectors
      </p>
    </div>

    <!-- Services Grid -->
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
      <div 
        *ngFor="let service of services; let i = index"
        class="group p-8 bg-white border border-slate-200 rounded-2xl hover:border-primary-500 hover:shadow-2xl transition-all duration-300 hover-lift"
        [style.animation]="'fadeInUp ' + (0.6 + i * 0.1) + 's ease-out'"
      >
        <!-- Icon -->
        <div class="w-16 h-16 mb-6 rounded-xl bg-gradient-to-br from-primary-100 to-accent-100 group-hover:from-primary-500 group-hover:to-accent-500 flex items-center justify-center transition-all duration-300">
          <svg 
            class="w-8 h-8 text-primary-600 group-hover:text-white transition-colors"
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path 
              *ngIf="service.icon === 'home'"
              stroke-linecap="round" 
              stroke-linejoin="round" 
              stroke-width="2" 
              d="M3 12l2-3m0 0l7-4 7 4M5 9v10a1 1 0 001 1h12a1 1 0 001-1V9m-9 11l4-4m0 0l4 4m-4-4V8m0 0L7 5m0 0v1a1 1 0 001 1h8a1 1 0 001-1V5m0 0L7 5"
            ></path>
            <path 
              *ngIf="service.icon === 'building'"
              stroke-linecap="round" 
              stroke-linejoin="round" 
              stroke-width="2" 
              d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4 0h1m-1 4h1m4 0h1m-1 4h1"
            ></path>
            <path 
              *ngIf="service.icon === 'bridge'"
              stroke-linecap="round" 
              stroke-linejoin="round" 
              stroke-width="2" 
              d="M13 10V3L4 14h7v7l9-11h-7z"
            ></path>
            <path 
              *ngIf="service.icon === 'palette'"
              stroke-linecap="round" 
              stroke-linejoin="round" 
              stroke-width="2" 
              d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.5a2 2 0 00-1 .267V5a2 2 0 10-4 0v.733a2 2 0 00-1-.733H7a2 2 0 00-2 2v4a2 2 0 002 2z"
            ></path>
            <path 
              *ngIf="service.icon === 'refresh'"
              stroke-linecap="round" 
              stroke-linejoin="round" 
              stroke-width="2" 
              d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
            ></path>
            <path 
              *ngIf="service.icon === 'chart'"
              stroke-linecap="round" 
              stroke-linejoin="round" 
              stroke-width="2" 
              d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
            ></path>
          </svg>
        </div>

        <!-- Content -->
        <h3 class="text-2xl font-bold text-slate-900 mb-3">{{ service.title }}</h3>
        <p class="text-slate-600 mb-6 leading-relaxed">{{ service.description }}</p>

        <!-- Features -->
        <div class="flex flex-wrap gap-2 mb-6">
          <span 
            *ngFor="let feature of service.features"
            class="text-sm px-3 py-1 bg-primary-50 text-primary-700 rounded-full font-medium"
          >
            {{ feature }}
          </span>
        </div>

        <!-- Link -->
        <a 
          [routerLink]="['/services', service.slug]"
          class="inline-flex items-center gap-2 text-primary-600 font-semibold group/link hover:text-primary-700 transition-colors"
        >
          Learn More
          <svg class="w-4 h-4 group-hover/link:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7l5 5m0 0l-5 5m5-5H6"></path>
          </svg>
        </a>
      </div>
    </div>

    <!-- Bottom CTA -->
    <div class="mt-16 text-center">
      <a 
        routerLink="/services"
        class="inline-block px-8 py-4 bg-gradient-to-r from-primary-600 to-accent-500 text-white font-bold rounded-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
      >
        Explore All Services
      </a>
    </div>
  </div>
</section>
